/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';
import { makeAsyncAction } from 'ui-permit/shared-components/utils/async';
import { FETCH_AVAILABILITY } from '../constants/actions';
import { LOCATION_TZ, BOOKING_HOUR_CUTOFF } from '../constants/hunting-permit-constants';
import * as api from '../api';

export const fetchAvailability = makeAsyncAction(
    FETCH_AVAILABILITY,
    (params) => () => {
        return api.fetchAvailability(params).then((res) => {
            const newPayload = [...res?.data?.payload].filter((p) => {
                const stringDateTime = `${p.permit_type_end} ${BOOKING_HOUR_CUTOFF[p.permit_id]}`;
                const permitEndDate = gnoment.tz(
                    stringDateTime,
                    LOCATION_TZ[p.permit_id]
                );
                return gnoment().isBefore(permitEndDate);
            });

            return { ...res, data: { payload: newPayload } };
        });
    },
    'payload'
);
